(function () {
    'use strict';

    angular.module("imApp").factory("shipmentContainersService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 771,
                    parameters: parms || {}
                });
            },
            listStatuses: function (parms) {
                return $ihttp.post({
                    method: 772,
                    parameters: parms || {}
                });
            },
            listContainers: function (parms) {
                return $ihttp.post({
                    method: 773,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
